export default __webpack_public_path__ + "static/media/profile_complete.ef21bcbd.png";